var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bs-container',{staticClass:"ui-toolbar mr-1",class:[_vm.theme,{wide:_vm.wide}],attrs:{"fluid":""}},[_c('bs-row',{staticStyle:{"flex-wrap":"nowrap"},attrs:{"h100":"","no-guttes":""}},[_vm._t("default")],2)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6cb6994c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/ui-toolbar/src/ui-toolbar.vue
// module id = 721
// module chunks = 0